export enum ObjectClass {
    unknown = 0,
    air = 1,
    road = 2,
    rail = 3,
    sea = 4,
    fixed = 5
}
